import {fetchUtils, simpleRestClient} from "admin-on-rest";
import {SERVICE_URL, USE_AUTHORIZATION} from "./api/constants";

const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
  }

  if(USE_AUTHORIZATION) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken')) ? JSON.parse(localStorage.getItem('accessToken')).data : null;
    
    options.headers.set('Authorization', `Bearer ${accessToken}`);
  }
  
  return fetchUtils.fetchJson(url, options);
};

export const RestClient = simpleRestClient(SERVICE_URL, httpClient);


// WEBPACK FOOTER //
// ./src/RestClient.js